import ComponentSelect2 from '@/components/ui/ComponentSelect2'

import { Button, Select } from '@mantine/core'
import SKU from '../ui/SKU'

export default function ComponentEditableList({ children, childrenHandlers }) {
    // Remove child
    const removeChild = (index) => {
        childrenHandlers.remove(index)
    }

    const quantitySelectData = [
        { value: '1', label: '1×' },
        { value: '2', label: '2×' },
        { value: '3', label: '3×' },
        { value: '4', label: '4×' },
        { value: '5', label: '5×' },
        { value: '6', label: '6×' },
        { value: '7', label: '7×' },
        { value: '8', label: '8×' },
        { value: '9', label: '9×' },
        { value: '10', label: '10×' },
    ]

    // Add child
    const addChild = (child) => {
        childrenHandlers.append({
            component_id: child.id,
            full_name: child.name,
            quantity: 1,
        })
    }

    // Sorted children
    const sortedChildren = children.sort((a, b) =>
        a.full_name < b.full_name ? -1 : 1
    )

    // Component children ids to exclude from component select
    const componentChildrenIds = children.map((child) => child.component_id)

    return (
        <div className="flex flex-col mb-5">
            <div className="">
                <ComponentSelect2
                    onSelect={addChild}
                    excludedIds={componentChildrenIds}
                />
            </div>

            <div className="flex flex-col gap-1 mt-3">
                {sortedChildren.map((child, index) => (
                    <div
                        className="flex gap-3 items-center"
                        key={child.component_id}
                    >
                        <Select
                            value={child.quantity.toString()}
                            data={quantitySelectData}
                            onChange={(value) => {
                                childrenHandlers.setItemProp(
                                    index,
                                    'quantity',
                                    value
                                )
                            }}
                            w="90px"
                        />

                        <SKU component={child} size="sm" />

                        <span>{child.full_name}</span>

                        <Button
                            onClick={() => removeChild(index)}
                            className="ml-auto"
                            variant="subtle"
                            color="gray"
                        >
                            Supprimer
                        </Button>
                    </div>
                ))}
            </div>
        </div>
    )
}
